import { MessageCircle } from "lucide-react";

export const WHATSAPP_NUMBER = "5215512345678";

export function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hola, me gustaría agendar una cita en Estética Lupita"
  )}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg transition-transform hover:scale-105"
    >
      <MessageCircle size={22} strokeWidth={2} />
      <span className="hidden text-sm font-medium sm:inline">WhatsApp</span>
    </a>
  );
}
